import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateBankAccountMutationVariables = Types.Exact<{
  account_id: Types.Scalars["String"];
  modification?: Types.Maybe<Types.Bank_Accounts_Set_Input>;
}>;

export type UpdateBankAccountMutation = { __typename?: "mutation_root" } & {
  update_bank_accounts_by_pk?: Types.Maybe<
    { __typename?: "bank_accounts" } & Pick<Types.Bank_Accounts, "account_id">
  >;
};

export const UpdateBankAccountDocument = gql`
  mutation UpdateBankAccount(
    $account_id: String!
    $modification: bank_accounts_set_input
  ) {
    update_bank_accounts_by_pk(
      pk_columns: { account_id: $account_id }
      _set: $modification
    ) {
      account_id
    }
  }
`;

export function useUpdateBankAccountMutation() {
  return Urql.useMutation<
    UpdateBankAccountMutation,
    UpdateBankAccountMutationVariables
  >(UpdateBankAccountDocument);
}
